import React from 'react'
import PropTypes from 'prop-types'
import { STATUS_FINISH, STATUS_PROCESS, STATUS_WAIT, StepItem, StepsBarWrapper } from './StepsIndicator.styles'
import Flex from '../Flex'
import Step from './Step'

function getStatus(selectedStep, currentStep) {
    if (selectedStep === currentStep) {
        return STATUS_PROCESS
    }
    if (selectedStep < currentStep) {
        return STATUS_FINISH
    }
    return STATUS_WAIT
}

export const Stepper = ({ currentStep, steps, goToStep, editIcon }) => {
    const handleKeyDown = ({e, step, status}) => {
        if (e.key === 'Enter' && status !== STATUS_WAIT) {
            goToStep({ step })
        }
    }
    return <StepsBarWrapper>
        {steps.map((step, index) => {
            const status = getStatus(index + 1, currentStep)
            const lastItem = index == steps.length - 1
            const minWidth = `calc(75% / ${steps.length})`
            const maxWidth = (100 - (75 / steps.length)) / (steps.length - 1) + '%'
            return <Flex tabIndex={0} onKeyDown={(e) => handleKeyDown({e, step: index + 1, status})} width={lastItem ? minWidth : maxWidth} flex='1' alignItems='flex-start' key={`Step__${index + 1}`} justifyContent='stretch'>
                <StepItem status={status} hideSeparator={lastItem} width='100%'>
                    <Step
                        status={status}
                        editIcon={editIcon}
                        nextStatus={getStatus(index + 1, currentStep)}
                        extraInfoComponent={step.extraInfoComponent}
                        currentStep={index + 1}
                        totalSteps={steps.length}
                        title={step.title}
                        stepCompletedTitle={step.stepCompletedTitle}
                        stepMobileTitle={step.stepMobileTitle}
                        goToStep={() => goToStep({ step: index + 1 })}
                        hideSeparator={lastItem} />
                </StepItem>
            </Flex>
        })}
    </StepsBarWrapper>
}
Stepper.propTypes = {
    currentStep: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(PropTypes.object).isRequired,
    goToStep: PropTypes.func.isRequired,
    editIcon: PropTypes.node,
}

export default Stepper
